import axios from "axios";
import Cookies from 'js-cookie';

const isDev = process.env.NODE_ENV === 'development';
const BACKEND_URL = isDev ? '' : process.env.REACT_APP_BACKEND_URL;
const API = BACKEND_URL
  ? `${BACKEND_URL.replace(/\/$/, '')}/api`
  : '/api';

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Add a request interceptor to include the auth token
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get('access_token');
    const hasAuthHeader = !!(config?.headers && (config.headers['Authorization'] || config.headers['authorization']));
    if (token && !hasAuthHeader) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export async function get(path, config = {}) {
  const res = await api.get(path, config);
  return res.data;
}

/**
 * Fetch multiple quotes in batch with concurrency control.
 * - Preferred: backend /api/quotes endpoint
 * - Fallback: Promise.allSettled of individual /api/quote calls
 */
export async function fetchBatchQuotes(symbols = [], market) {
  const syms = Array.isArray(symbols) ? symbols.filter(Boolean) : [];
  if (!syms.length) return [];
  try {
    const params = { symbols: syms.join(',') };
    if (market) params.market = market;
    const res = await api.get('/quotes', { params });
    const out = res?.data?.results || [];
    return out;
  } catch (e) {
    // Fallback to per-symbol calls with Promise.allSettled
    const settled = await Promise.allSettled(
      syms.map((s) => api.get('/quote', { params: { symbol: s, market } }))
    );
    return settled.map((r, i) => {
      if (r.status === 'fulfilled') return r.value.data;
      return { symbol: syms[i].toUpperCase(), error: String(r.reason?.message || r.reason || 'failed') };
    });
  }
}

export default api;